import styled from 'styled-components';

const AddNewProductContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h4, input {
        margin: .5rem 0rem;
    }
    button {
        margin-right: .7rem;
    }
`;

export { AddNewProductContainer }